<template>

    <Toast/>

    <MenuLogin/>

    <div class="px-6 surface-overlay relative">

        <div class="border-2 surface-border border-round surface-section flex-auto">

            <div class="flex flex-wrap">

                <div v-show="activeTab === 1" class="w-full lg:w-12 p-4 lg:p-7 surface-card">
                    <div class="text-900 text-2xl font-medium mb-6">Login</div>

                    <div class="field">
                        <label for="username" class="block text-900 font-medium mb-2">Username</label>
                        <InputText id="username" type="text" v-model="userData.username" placeholder="Username"
                                   class="w-full mb-4"/>
                    </div>

                    <div class="field">
                        <label for="password" class="block text-900 font-medium mb-2">Password</label>

                        <InputText id="password"
                                   :type="showPassword ? 'text' : 'password'"
                                   v-model="userData.password"
                                   placeholder="Password"
                                   class="w-full pr-10 mb-4"/>
                    </div>

                    <!-- Show Password Toggle -->
                    <div class="flex align-items-center justify-content-between mb-6">
                        <div class="flex align-items-center">
                            <Checkbox id="showPasswordToggle" :binary="true" v-model="showPassword"
                                      class="mr-2"></Checkbox>
                            <label for="showPasswordToggle">Show Password</label>
                        </div>
                        <div class="flex align-items-center">
                            <Checkbox id="rememberme" :binary="true" v-model="rememberme"
                                      class="mr-2"></Checkbox>
                            <label for="rememberme">Remember me</label>
                        </div>
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleForgotPassword">
                            Forgot password?
                        </a>
                    </div>

                    <div class="flex align-items-center align-content-center justify-content-between mb-6">
                      <span>
                          By proceeding, you agree to the
                        <a href='https://kitrin.com/terms' target='_blank'>Terms of Use</a>
                        , <a href='https://kitrin.com/privacy' target='_blank'>Disclaimer</a>
                        , and <a href='https://kitrin.com/privacy' target='_blank'>Privacy Policy</a>
                      </span>
                    </div>

                    <Button label="Login" icon="pi pi-user" class="w-full" :loading="submitted"
                            @click="handleLogin"></Button>

                    <!--                    <div class="mt-6 text-center text-600">-->
                    <!--                        Don't have an account?-->
                    <!--                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"-->
                    <!--                           @click="handleRegister">Sign Up</a>-->
                    <!--                    </div>-->
                </div>

                <div v-show="activeTab === 2" class="w-full lg:w-6 p-4 lg:p-7 surface-card">
                    <div class="text-900 text-2xl font-medium mb-6">Login</div>

                    <div class="field">
                        <p class="text-600 line-height-3 mt-0 mb-4">
                            A One-Time Pin (OTP) has been emailed to you at {{ maskedEmail }}.
                            <br><br>
                            Didn't receive your OTP after 5 minutes? Please check your spam or junk folder first.
                            If it's not there, you can temporarily regain access by clicking on "Forgot Password?" below
                            to
                            reset your password.
                            <br><br>
                            If you don't have access to your email or aren't receiving our emails, please contact
                            info@kitrin.com for help.
                        </p>
                    </div>

                    <div class="field">
                        <label for="activationCode" class="block text-900 font-medium mb-2">Email OTP (begins with
                            {{ otpHint }})</label>
                        <InputText id="activationCode" type="text" v-model="userData.activationCode"
                                   placeholder="Enter the 6-digit OTP sent via email"
                                   class="w-full mb-4"/>
                    </div>

                    <div class="flex align-items-center align-content-center justify-content-between mb-6">
                      <span>
                          By proceeding, you agree to the
                        <a href='https://kitrin.com/terms' target='_blank'>Terms of Use</a>,
                        <a href='https://kitrin.com/terms' target='_blank'>Disclaimer</a> and
                        <a href='https://kitrin.com/privacy' target='_blank'>Privacy Policy</a>
                      </span>
                    </div>

                    <Button label="Login" icon="pi pi-user" class="w-full" :loading="submitted"
                            @click="handleVerifyTfa"></Button>

                    <div class="mt-6 text-center text-600">
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleCancel">Back to Login?</a>
                    </div>

                    <div class="mt-6 text-center text-600">
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleForgotPassword">Forgot password?</a>
                    </div>

                </div>

            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuLogin from "@/components/menu/authentication/MenuLogin.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import AuthenticationService from "@/service/AuthenticationService";
import CompanyService from "@/service/CompanyService";
import DashboardService from "@/service/DashboardService";
import AuditTrailService from "@/service/AuditTrailService";
import ProductService from "@/service/ProductService";
import PractitionerService from "@/service/PractitionerService";
import LocationService from "@/service/LocationService";
import BillingPlanService from "@/service/BillingPlanService";
import SupplierService from "@/service/SupplierService";
import ClientService from "@/service/ClientService";

export default {
    components: {
        MenuLogin,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            await UserService.getUserPing();
        } catch (e) {
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        this.activeTab = 1;
        this.userData = {};
        this.userData.username = '';
        this.userData.password = '';
        this.userData.activationCode = '';
        this.submitted = false;
    },
    data() {
        return {
            activeTab: 1,
            userData: {},
            profile: {},
            userConfiguration: {},
            submitted: false,
            rememberme: false,
            showPassword: false,
            tfaRequired: false,
            maskedEmail: null,
            otpHint: null,
            deliveryHint: null,
        }
    },
    methods: {
        handleResult(index, result) {
            switch (index) {
                case 0:
                    this.userStore.setCompanyConfiguration(result.data);
                    break;
                case 1:
                    this.userStore.setFinancialSummary(result.data);
                    break;
                case 2:
                    this.userStore.setAuditTrails(result.data);
                    break;
                case 3:
                    this.userStore.setUsers(result.data);
                    break;
                case 4:
                    this.userStore.setProducts(result.data);
                    break;
                case 5:
                    this.userStore.setPractitioners(result.data);
                    break;
                case 6:
                    this.userStore.setLocations(result.data);
                    break;
                case 7:
                    this.userStore.setBillingPlans(result.data);
                    break;
                case 8:
                    this.userStore.setSuppliers(result.data);
                    break;
                case 9:
                    this.userStore.setClients(result.data);
                    break;
            }
        },
        loadDataInBackground() {
            const promises = [
                CompanyService.getCompanyConfiguration(this.userStore.user.companyId),
                DashboardService.getFinancialSummaryOverThreeMonthsForCompany(this.userStore.user.companyId),
                AuditTrailService.getCompanyAuditTrails(this.userStore.user.companyId),
                UserService.getCompanyUsers(this.userStore.user.companyId),
                ProductService.getCompanyProducts(this.userStore.user.companyId),
                PractitionerService.getCompanyPractitioners(this.userStore.user.companyId),
                LocationService.getCompanyLocations(this.userStore.user.companyId),
                BillingPlanService.getActiveBillingPlans(this.userStore.user.companyId),
                SupplierService.getCompanySuppliers(this.userStore.user.companyId),
                ClientService.getBasicCompanyClients(this.userStore.user.companyId)
            ];

            // Run the promises but do not await them.
            promises.forEach((promise, index) => {
                promise.then(result => {
                    // Handle the result here, e.g., assign to a data property
                    this.handleResult(index, result);
                })
            });
        },
        async handleLogin() {
            this.submitted = true;

            try {
                var createData = {
                    username: this.userData.username,
                    password: this.userData.password,
                    activationCode: this.userData.activationCode,
                };

                const responseData = await AuthenticationService.authenticateUser(createData);

                if (responseData.status === 202) {
                    this.tfaRequired = true;
                    this.activeTab = 2;
                    this.submitted = false;

                    if (responseData.data && responseData.data.deliveryHint) {
                        this.maskedEmail = responseData.data.deliveryHint;
                        this.otpHint = responseData.data.otpHint;
                    }

                    return;
                }

                // If we get here, we expect HTTP 200 + JwtResponse → no TFA needed
                this.tfaRequired = false;

                this.userStore.setUserToken(responseData.data);

                if (this.userStore.companies.length > 0) {
                    this.userStore.activeCompanyId = this.userStore.companies[0].id;
                }

                const promises = [
                    UserService.getUser(responseData.data.id),
                    UserService.getUserConfig(responseData.data.id)
                ];

                const [userResult, userConfigResult] =
                    await Promise.allSettled(promises);

                if (userResult.status === "fulfilled") {
                    this.userStore.setUser(userResult.value.data);
                }

                if (userConfigResult.status === "fulfilled") {
                    this.userStore.setUserConfiguration(userConfigResult.value.data);
                    this.userConfiguration = userConfigResult.value.data;
                }

                this.loadDataInBackground();

                if (this.userStore.user) {

                    if (this.userStore.user.roles.includes("ROLE_ISOEVOLVE", 0)) {
                        this.$router.push("healthOverviewHome");

                        if (this.userConfiguration.showSurvey === 'Y') {
                            this.$router.push("commonSurvey");
                        } else {
                            if (this.userConfiguration.showFeature === 'Y') {
                                this.$router.push("commonFeature");
                            } else {
                                if (this.userConfiguration.showWelcome === 'Y') {
                                    this.$router.push("commonHelp");
                                } else {
                                    this.$router.push("healthOverviewHome");
                                }
                            }
                        }

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Login successful',
                            life: 3000
                        });

                    } else if (this.userStore.user.roles.includes("ROLE_ISOPRACTICE", 0)) {

                        if (this.userConfiguration.showSurvey === 'Y') {
                            this.$router.push("commonSurvey");
                        } else {
                            if (this.userConfiguration.showFeature === 'Y') {
                                this.$router.push("commonFeature");
                            } else {
                                if (this.userConfiguration.showWelcome === 'Y') {
                                    this.$router.push("commonHelp");
                                } else {
                                    this.$router.push("healthOverviewHome");
                                }
                            }
                        }

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Login successful',
                            life: 3000
                        });

                    } else if (this.userStore.user.roles.includes("ROLE_ISORISE", 0)) {
                        this.$router.push("faOverviewHome");

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Login successful',
                            life: 3000
                        });

                    } else if (this.userStore.user.roles.includes("ROLE_ISOWEB", 0)) {
                        this.$router.push("siLogin");

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to login. Please try again.',
                            life: 3000
                        });
                    } else if (this.userStore.user.roles.includes("ROLE_ISODEBT", 0)) {
                        this.$router.push("cpOverviewHome");

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Login successful',
                            life: 3000
                        });

                    } else {
                        this.$router.push("userOverview");

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Login successful',
                            life: 3000
                        });

                    }
                }

                this.activeTab = 1;
                this.userData = {};
                this.userData.username = '';
                this.userData.password = '';
                this.userData.activationCode = '';
                this.submitted = false;

            } catch (error) {
                if (error.response && error.response.status === 429) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Please wait",
                        detail: "OTP already issued. Please try again in 1 minute.",
                        life: 4000,
                    });

                } else {
                    // Default error handling for other statuses (403, 500, etc.)
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Failed to login. Please try again.",
                        life: 3000,
                    });
                }

                this.activeTab = 1;
                this.userData = {};
                this.userData.username = '';
                this.userData.password = '';
                this.userData.activationCode = '';
                this.submitted = false;
            }
        },
        async handleVerifyTfa() {
            this.submitted = true;

            try {
                const payload = {
                    username: this.userData.username,
                    code: this.userData.activationCode, // matches your backend DTO
                };

                const response = await AuthenticationService.verifyTfa(payload);

                await this.finishLogin(response.data);

            } catch (error) {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Invalid or expired verification code. Please try again.",
                    life: 3000,
                });

                this.submitted = false;
            }
        },
        async finishLogin(jwtResponse) {
            this.userStore.setUserToken(jwtResponse);

            const promises = [
                UserService.getUser(jwtResponse.id),
                UserService.getUserConfig(jwtResponse.id),
            ];

            const [userResult, userConfigResult] = await Promise.allSettled(promises);

            if (userResult.status === "fulfilled") {
                this.userStore.setUser(userResult.value.data);
            }

            if (userConfigResult.status === "fulfilled") {
                this.userStore.setUserConfiguration(userConfigResult.value.data);
                this.userConfiguration = userConfigResult.value.data;
            }

            this.loadDataInBackground();

            if (this.userStore.user) {
                if (this.userStore.user.roles.includes("ROLE_ISOEVOLVE")) {
                    if (this.userConfiguration.showSurvey === 'Y') {
                        this.$router.push("commonSurvey");
                    } else {
                        if (this.userConfiguration.showFeature === 'Y') {
                            this.$router.push("commonFeature");
                        } else {
                            if (this.userConfiguration.showWelcome === 'Y') {
                                this.$router.push("commonHelp");
                            } else {
                                this.$router.push("healthOverviewHome");
                            }
                        }
                    }

                } else if (this.userStore.user.roles.includes("ROLE_ISOPRACTICE")) {
                    if (this.userConfiguration.showSurvey === 'Y') {
                        this.$router.push("commonSurvey");
                    } else {
                        if (this.userConfiguration.showFeature === 'Y') {
                            this.$router.push("commonFeature");
                        } else {
                            if (this.userConfiguration.showWelcome === 'Y') {
                                this.$router.push("commonHelp");
                            } else {
                                this.$router.push("healthOverviewHome");
                            }
                        }
                    }

                } else if (this.userStore.user.roles.includes("ROLE_ISORISE")) {
                    this.$router.push("faOverviewHome");
                } else if (this.userStore.user.roles.includes("ROLE_ISODEBT")) {
                    this.$router.push("cpOverviewHome");
                } else if (this.userStore.user.roles.includes("ROLE_ISOWEB")) {
                    this.$router.push("siLogin");

                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Failed to login. Please try again.",
                        life: 3000,
                    });
                } else {
                    this.$router.push("userOverview");
                }

                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Login successful",
                    life: 3000,
                });
            }

            // Reset UI state
            this.activeTab = 1;
            this.tfaRequired = false;
            this.userData = {
                username: "",
                password: "",
                activationCode: "",
            };
            this.submitted = false;
        },
        handleCancel() {
            this.activeTab = 1;
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Reset Back to Login',
                life: 3000
            });
        },
        handleForgotPassword() {
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Password Reset Initiated',
                life: 3000
            });
            this.$router.push("forgotPassword");
        },
        handleRegister() {
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Registration Initiated',
                life: 3000
            });
            this.$router.push("register");
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
